module.exports = __webpack_public_path__ + "img/hor-desc.c96aeed2.png";